import type { LicenseDetails } from '#shared/types/core/external/license'

export function useLicensesApi() {
  const api = useCoreApi('external/frontend/licenses')

  return {
    async getLicenseDetails() {
      return await api.$fetch<Array<LicenseDetails>>(api.endpoint('details'))
    },
  }
}
